import { injectable } from "inversify";
import Download from "./Download";
import { MimeTypes } from "../types";

@injectable()
export default class DownloadPFXFile extends Download {
  getMimeType(): string {
    return MimeTypes.PFX;
  }

  execute(file: Blob, fileName: string): void {
    super.execute(file, fileName);
  }
}
